import React from "react";

import {
  DocumentText,
  LightBulb,
  PaperAirplane,
} from "../../../components/icons/svg/outline";
import { getProjectTitle } from "../../../utils/business";
import { useProjectPageContext } from "./ProjectPageContext";
import ProjectSectionTitle from "./ProjectSectionTitle";

/**
 * Render the project AI assistant tab placeholder.
 *
 * @returns {JSX.Element}
 */
const ProjectAssistant = () => {
  const { project, placeholderContent } = useProjectPageContext();
  const { assistant } = placeholderContent;

  return (
    <section className="rounded-xl border border-gray-200 bg-white shadow-sm shadow-primary-900/5">
      <div className="border-b border-gray-200 p-4">
        <ProjectSectionTitle className="mb-0">
          {assistant.title}
        </ProjectSectionTitle>
        <p className="mt-1 text-sm text-gray-500">
          {assistant.promptPrefix} {getProjectTitle(project)}
        </p>
      </div>

      <div className="border-b border-gray-200 bg-gray-50 px-4 py-3">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">
          {assistant.includedDocumentsLabel}
        </p>
        <div className="mt-2 flex flex-wrap gap-2">
          {assistant.includedDocuments.map((documentName) => (
            <span
              key={documentName}
              className="inline-flex items-center gap-1 rounded-full bg-primary px-3 py-1 text-xs font-semibold text-white"
            >
              <DocumentText className="h-3.5 w-3.5" />
              {documentName}
            </span>
          ))}
        </div>
      </div>

      <div className="flex min-h-[320px] flex-col items-center justify-center px-4 py-8 text-center">
        <LightBulb className="h-10 w-10 text-gray-300" />
        <p className="mt-4 text-sm font-semibold text-gray-600">
          {assistant.placeholder}
        </p>
        <p className="mt-2 text-sm text-gray-500">
          {assistant.description}
        </p>
      </div>

      <div className="flex items-center gap-2 border-t border-gray-200 p-4">
        <div className="flex h-11 flex-1 items-center rounded-lg border border-gray-200 bg-gray-50 px-3 text-sm text-gray-500">
          {assistant.inputPlaceholder}
        </div>
        <button
          type="button"
          className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-primary text-white shadow-sm transition hover:bg-primary-300 focus:outline-none focus:ring-4 focus:ring-primary-100"
          aria-label="Send project assistant message"
        >
          <PaperAirplane className="h-5 w-5" />
        </button>
      </div>
    </section>
  );
};

export default ProjectAssistant;
